import { Component, OnInit, ViewChild } from '@angular/core';
import { RightSideDrawerService } from '../right-side-drawer.service';
import { SessionService } from '../../session-service/session.service';
import { MasterActivitiesService } from '../../../admin/master-activities/master.activities.service';
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormControl,
  AbstractControl,
} from '@angular/forms';
import { MasterActivities } from '../../models/master-activity/master-activities.model';
import { ToastrService } from '@kpmg-tax/ui';
import { API_URL } from '../../constants/apiurl-constants';

import { CustomDropdownComponent } from '../../custom-dropdown/custom-dropdown.component';
import { Messages } from '../../constants/messages';
import { Observable, of, Subject } from 'rxjs';
import {
  catchError,
  debounceTime,
  distinctUntilChanged,
  switchMap,
  tap,
} from 'rxjs/operators';
import { ActivitySubTypeEnum, ActivityTypeEnum, } from '../../constants/activity-type.enum';
import { MasterActivity } from '../../models/master-activity-model';
import { MasterActivityFlagOptions } from './model/master-activty.model';
import { ACTIVITY_CONSTANTS, ACTIVITY_SUBTYPE_CONSTANTS, ACTIVITYSUBTYPES, APP_CONSTANTS } from '../../constants/app-constants';
import { encodeText } from 'src/app/shared/lib/custom-tools';
import { CustomDropDown } from '../../models/custom-dropdown.model';
import { WhiteSpaceValidator } from 'src/app/core/validators/whitespace-validator';

@Component({
  selector: 'add-update-masterActivity',
  templateUrl: './add-update-activity.component.html',
  styleUrls: ['./add-update-activity.component.scss'],
})
export class AddUpdateMasterActivityComponent implements OnInit {
  masterActivityFlagOptions: MasterActivityFlagOptions;
  activityFlagOptionId: number = 0; // Activity Flag is selected by default
  targetForm: FormGroup;
  activity: MasterActivities;
  isAddActivity: boolean;
  editRowData: any;
  public _masterActivity: Array<MasterActivities>;
  isDisabled: boolean = true;
  activityGroupData: string = '';
  activityGroupList: Array<MasterActivities> = [];
  isActivityGroupSelected: boolean = false;
  isNQA: boolean = false;
  isActivityEntered: boolean = false;
  masterActivityGroupList: any;
  activityGroupObserver: Subject<string> = new Subject<string>();
  editActivityName: any;
  dropdownOptions: CustomDropDown[] = [];
  showActivitySubTypeValidation: boolean;
  selectedActivitySubType: string = '';
  selectedActivitySubTypeId: number;
  @ViewChild(CustomDropdownComponent) private customDropdownComponent!: CustomDropdownComponent;
  isActivitySubTypeSelected: boolean = false;
  disableActivitySubtype: boolean = false;

  constructor(
    public rightSideDrawerService: RightSideDrawerService,
    public _masterActivitiesService: MasterActivitiesService,
    public sessionService: SessionService,
    public _toasterService: ToastrService,
    public formBuilder: FormBuilder,
  ) {
    this.masterActivityFlagOptions = new MasterActivityFlagOptions();
    this.dropdownOptions = this.getActivtiySubTypeOptions();
  }

  ngOnInit() {
    this.editRowData = this.rightSideDrawerService.singleRowEditData;
    this._masterActivity = this.rightSideDrawerService.multipleRowAddData;

    if ((this.rightSideDrawerService.singleRowEditData == null) || (typeof this.rightSideDrawerService.singleRowEditData === 'undefined')) {
      this.resetRightSideDrawerDataAdd();
      this.isAddActivity = true;
    } else {
      this.resetRightSideDrawerDataUpdate();
      this.isAddActivity = false;
      this.isDisabled = true;
      this.masterActivityFlagOptions.options.map(flag => {
        if (flag.id === this.editRowData.activityType) {
          flag.isSelected = true;
        } else {
          flag.isSelected = false;
        }

      })
      this.activityFlagOptionId = this.editRowData.activityType
    }
    this._masterActivitiesService.GetActivityGroup().subscribe((data: any) => {
      this.activityGroupList = data.result;

      this.masterActivityGroupList = this.activityGroupList.filter(x => x.activityGroup).map(x => x.activityGroup);

      this.masterActivityGroupList = this.masterActivityGroupList.reduce((result, element) => {
        let normalize = x => typeof x === 'string' ? x.toLowerCase() : x;

        let normalizedElement = normalize(element);
        if (result.every(otherElement => normalize(otherElement) !== normalizedElement)) {
          result.push(element);
        }

        return result;
      }, []);

    });    

  }

  trimSpecialChar(ctrl: any) {
    if (ctrl === 'activityGroup') {
      let activityGroupInput =
        this.targetForm.get('activityGroup').value.activityGroup ||
        this.targetForm.get('activityGroup').value;
      this.targetForm.controls[ctrl].setValue(
        activityGroupInput.replace(/[^a-zA-Z0-9-()._#!$%^+=&,*@/ ]/g, ''),
      );
    } else {
      this.targetForm.controls[ctrl].setValue(
        this.targetForm.get(ctrl).value.replace(/[^a-zA-Z0-9-()._#!$%^+=&,*@/ ]/g, ''),
      );
    }

    this.OnActivityChange();
  }

  // reference to form fields
  get f() {
    return this.targetForm?.controls;
  }

  UniqueActivityNameAdd(activityList: Array<MasterActivities>) {
    return (control: AbstractControl): { [key: string]: any } => {
      const actName = this.trim(control.value).toUpperCase();
      if (
        activityList.find(x => x.name.toUpperCase() === actName) !== undefined
      ) {
        return { UniqueAName: true };
      }
      return null;
    };
  }

  UniqueActivityNameUpdate(
    activityList: Array<MasterActivities>,
    row: MasterActivities,
  ) {
    return (control: AbstractControl): { [key: string]: any } => {
      const actName = this.trim(control.value).toUpperCase();
      if
        ((this.isAddActivity &&
          row.name.toUpperCase() !== actName &&
          activityList.find(x => x.name.toUpperCase() === actName) !== undefined)
        ||
        (!this.isAddActivity &&
          row.name.toUpperCase() !== actName &&
          (activityList.find(x => x.name.toUpperCase() === actName) !== undefined) || actName === this.editActivityName)) {
        {
          return { UniqueAName: true };
        }
        return null;
      }
    };
  }

  public resetRightSideDrawerDataAdd = () => {
    this.targetForm = this.formBuilder.group({
      qpercentage: [
        '100',
        [
          Validators.required,
          Validators.pattern('^[0-9]+(.[0-9]{1,2})?$'),
          Validators.min(0),
          Validators.max(100),
        ],
      ],
      name: [
        '',
        [
          Validators.required,
          Validators.maxLength(100),
          WhiteSpaceValidator.cannotContainSpace,
          this.UniqueActivityNameAdd(this._masterActivity),
        ],
      ],
      activityGroup: ['', [Validators.required, Validators.maxLength(100),WhiteSpaceValidator.cannotContainSpace]],
      description: ['', [Validators.maxLength(500)]],
      activitySubType: ['']
    });
  }

  public resetRightSideDrawerDataUpdate = () => {
    this.targetForm = new FormGroup({
      name: new FormControl(
        this.rightSideDrawerService.singleRowEditData.name,
        [
          Validators.required,
          Validators.maxLength(100),WhiteSpaceValidator.cannotContainSpace,
          this.UniqueActivityNameUpdate(
            this._masterActivity,
            this.rightSideDrawerService.singleRowEditData,
          ),
        ],
      ),
      activityGroup: new FormControl(
        this.rightSideDrawerService.singleRowEditData.activityGroup,
        [Validators.required, Validators.maxLength(100),WhiteSpaceValidator.cannotContainSpace],
      ),
      description: new FormControl(
        this.rightSideDrawerService.singleRowEditData.desc,
        [Validators.maxLength(500)],
      ),
      qpercentage: new FormControl(
        this.rightSideDrawerService.singleRowEditData.qPercentage,
        [
          Validators.required,
          Validators.pattern('^[0-9]+(.[0-9]{1,2})?$'),
          Validators.min(0),
          Validators.max(100),
        ],
      )
    });
    this.targetForm.controls['activityGroup'].setValue(
      this.rightSideDrawerService.singleRowEditData.activityGroup,
    );
    this.isNQA = this.rightSideDrawerService.singleRowEditData.activityType === ActivityTypeEnum.NQA;

    if (this.rightSideDrawerService.singleRowEditData.activityType === ActivityTypeEnum.NQA
      || this.rightSideDrawerService.singleRowEditData.activityType === ActivityTypeEnum.NWT
      || this.rightSideDrawerService.singleRowEditData.subTypeName === ACTIVITY_SUBTYPE_CONSTANTS.NQ41Q174
    ) {
      this.disableActivitySubtype = true;
      this.targetForm.controls['activityGroup'].disable();
      this.targetForm.controls['qpercentage'].disable();
    } else {
      this.disableActivitySubtype = false;
      this.targetForm.controls['activityGroup'].enable();
      this.targetForm.controls['qpercentage'].enable();
    }

    this.selectedActivitySubType = this.rightSideDrawerService.singleRowEditData.subTypeName;
    this.selectedActivitySubTypeId = this.rightSideDrawerService.singleRowEditData.activityType;
  }

  addEditActivity = (flag: boolean) => {
    let eid = this.sessionService.getSession('engagementId');
    if (flag) {
      this.AddActivity();
    } else {
      this.EditActivity();
    }
  }

  AddActivity() {
    this.activityGroupValidation();

    this.isDisabled = false;
    let activityGroupInput =
      this.targetForm.get('activityGroup').value.activityGroup ||
      this.targetForm.get('activityGroup').value;

    let activity: MasterActivity = {
      name: encodeText(this.targetForm.get('name').value),
      activityGroup: encodeText(activityGroupInput),
      desc: encodeText(this.targetForm.get('description').value),
      qPercentage: this.targetForm.get('qpercentage').value,
      activityType: this.selectedActivitySubTypeId,
      subTypeName: this.selectedActivitySubType,
      engagementId: +this.sessionService.getSession('engagementId'),
    };

    this.sessionService.apiUrlPost(API_URL.MASTERACTIVITY.ADDACTIVITY, activity).subscribe(data => {
      this.rightSideDrawerService.closeRightSideDrawer();
      this._masterActivitiesService.refreshTable();
      this._toasterService.setSuccessMessage(
        Messages.Admin.MasterActivity.ACTIVITY_ADDED_SUCCESS,
      );
    });
  }

  EditActivity() {
    this.isDisabled = true;
    let activityGroupInput = this.getActivityGroupFormValue();
    this.editActivityName = this.targetForm.get('name').value;
    let activity: MasterActivity = {
      activityID: this.editRowData.activityID,
      name: encodeText(this.targetForm.get('name').value),
      activityGroup: encodeText(activityGroupInput),
      desc: encodeText(this.targetForm.get('description').value),
      qPercentage: this.targetForm.get('qpercentage').value,
      activityType: this.selectedActivitySubTypeId,
      subTypeName: this.selectedActivitySubType,
      engagementId: +this.sessionService.getSession('engagementId'),
    };

    this.sessionService.apiUrlPost(API_URL.MASTERACTIVITY.UPDATEACTIVITY, activity).subscribe(data => {
      this._masterActivitiesService.refreshTable();
      this.rightSideDrawerService.closeRightSideDrawer();
      this._toasterService.setSuccessMessage(Messages.Admin.MasterActivity.ACTIVITY_UPDATE_SUCCESS);
    });
  }

  private getActivityGroupFormValue(): string {
    var rawFormValue = this.targetForm.get('activityGroup').value;
    if (rawFormValue == null || rawFormValue == undefined)
      return "";
    if (rawFormValue.activityGroup == null || rawFormValue.activityGroup == undefined)
      return rawFormValue.trim();
    return rawFormValue.activityGroup.trim();
  }

  trim(x) {
    return x ? x.replace(/^\s+|\s+$/gm, '') : '';
  }


  OnActivityChange() {
    let activityGroupInput = this.getActivityGroupFormValue();
    let activity: any = {
      name: this.targetForm.get('name').value,
      activityGroup: activityGroupInput,
      desc: this.targetForm.get('description').value,
      qPercentage: this.targetForm.get('qpercentage').value,
      activityType: this.selectedActivitySubTypeId,
      subTypeName: this.selectedActivitySubType
    };
    if (this.isAddActivity) {
      if (
        (activity.name !== null && activity.name.trim().length > 0) ||
        (activity.activityGroup !== null && activity.activityGroup.trim().length > 0) ||
        activity.desc !== null ||
        activity.qPercentage !== null
      ) {
        this.isDisabled = false;
        this.rightSideDrawerService.setMandatoryField(true, 'Add Activity');
      } else {
        this.isDisabled = true;
        this.rightSideDrawerService.setMandatoryField(false, '');
      }
    } else {
      if (
        (activity.name && activity.name.trim().length > 0 && activity.name !== this.editRowData.name) ||
        (activity.activityGroup && activity.activityGroup !== this.editRowData.activityGroup) ||
        (activity.desc !== this.editRowData.desc) ||
        activity.qPercentage !== this.editRowData.qPercentage ||
        activity.activityType !== this.editRowData.activityType ||
        activity.subTypeName !== this.editRowData.subTypeName
      ) {
        this.isDisabled = false;
        this.rightSideDrawerService.setMandatoryField(false, '');
      } else {
        this.isDisabled = true;
        this.rightSideDrawerService.setMandatoryField(true, 'Edit Master Activity');
      }
    }
  }

  //KPMGUiTypeahead will override activityGroupValidation without a slight delay in the function call (but only from a user standpoint. Submitting will provide the correct values).
  activityGroupValidationDelayer(activityGroup: string) {
    if (this.activityGroupObserver.observers.length === 0) {
      this.activityGroupObserver
        .pipe(debounceTime(200))
        .subscribe(() => {
          this.activityGroupValidation();
        });
    }

    this.activityGroupObserver.next(activityGroup);
  }

  // 1. Checks if the user entered in a non-qualified activity but did not hit the "Non-Qualified Activity" switch.
  // 2. Checks if the user entry matches a previous activity group, but in a different case. If so, changes to that.
  activityGroupValidation() {
    let activityGroupInput = this.targetForm.get('activityGroup').value;
    let activityGrounName;
    if (activityGroupInput.activityGroup === undefined) {
      activityGrounName = activityGroupInput;
    } else {
      activityGrounName = activityGroupInput.activityGroup;
    }

    if (activityGrounName.toUpperCase() == APP_CONSTANTS.NQA && this.isNQA == false) {
      this.isNQA = true;
      this.targetForm.patchValue({ activityGroup: APP_CONSTANTS.NQA });
    } else {
      for (let activity of this.masterActivityGroupList) {
        if (activityGrounName.toLowerCase() == activity.toLowerCase()) {
          this.targetForm.patchValue({ activityGroup: activity });
          break;
        }
      }
    }

    if (activityGrounName.toLowerCase() == APP_CONSTANTS.NWT.toLowerCase()) {
      this.targetForm.patchValue({ activityGroup: APP_CONSTANTS.NWT });
    }

    this.masterActivityFlagOptions.options.forEach(option => {
      if (activityGrounName.toString().toLowerCase() === APP_CONSTANTS.NQA.toLowerCase()) {
        option.isSelected = option.value.toLowerCase() === APP_CONSTANTS.NQA.toLowerCase() ? true : false;
      } else if (activityGrounName.toString().toLowerCase() === APP_CONSTANTS.NWT.toLowerCase()) {
        option.isSelected = option.value.toLowerCase() === APP_CONSTANTS.NWT.toLowerCase() ? true : false;
      }
    });
  }

  searchExistingActivityGroup = (searchPhrase$: Observable<any>) =>
    searchPhrase$.pipe(
      debounceTime(150), // Wait 150 milliseconds for typing to stop
      distinctUntilChanged(), // Only continue if the current search term is different that it was before the user started typing
      tap(term => {
        // Remove "no results" message in case it was displayed from the previous search
        //this.noResults = false;
      }),
      switchMap(term => {
        // Process the search term entered
        return this.searchActivityGroup(term).pipe(
          switchMap(data => {
            this.activityGroupData = term as string;
            return of(data);
          }),
          catchError(() => {
            return of([]);
          }),
        );
      }),
    )

  // Filter clients autosuggest
  private searchActivityGroup(term: any): Observable<any> {
    if (this.activityGroupList) {
      return of(
        this.activityGroupList.filter((item: any) =>
          item.activityGroup.toLowerCase().includes(term.toLowerCase()) 
        && item.activityGroup.toLowerCase() != 'nqa'
        && item.activityGroup.toLowerCase() !== 'non-working time'
        ),
      );
    } else {
      return of([]);
    }
  }

  onActivityGroupSelected($event: any) {
    this.activityGroupData = $event.item.activityGroup;
    this.isActivityGroupSelected = true;
  }

  activityNamechange() {
    let activityName = this.targetForm.get('name').value;
    let activityGroup =
      this.targetForm.get('activityGroup').value.activityGroup ||
      this.targetForm.get('activityGroup').value;
    if (
      activityName &&
      activityName.trim().length > 0 &&
      activityGroup &&
      activityGroup.trim().length > 0
    ) {
      this.isActivityEntered = true;
    } else {
      this.isActivityEntered = false;
    }
  }

  flagOptionClick(optionId: number) {
    this.activityFlagOptionId = optionId;
    this.isNQA = optionId === ActivityTypeEnum.NQA;
    if (optionId === ActivityTypeEnum.NQA || optionId === ActivityTypeEnum.NWT) {
      this.targetForm.patchValue({ activityGroup: optionId === ActivityTypeEnum.NQA ? APP_CONSTANTS.NQA : APP_CONSTANTS.NWT, qpercentage: 0 });
      this.targetForm.controls['activityGroup'].disable();
      this.targetForm.controls['qpercentage'].disable();
    } else {
      this.targetForm.patchValue({ activityGroup: '', qpercentage: 100 });
      this.targetForm.controls['activityGroup'].enable();
      this.targetForm.controls['qpercentage'].enable();
    }
    if (!this.isAddActivity) {
      this.OnActivityChange();
    }
  }

  // format for clients search
  ActivityGroupFormatter = (result: any) =>
    typeof result.activityGroup === 'undefined' ? result : result.activityGroup


  private getActivtiySubTypeOptions(): CustomDropDown[] {
    const activitySubTypeOptions = ACTIVITYSUBTYPES.filter(item => item.activitySubType !== ActivitySubTypeEnum['Non-working Time']);
    const options: CustomDropDown[] = [{ id: 0, value: '', isDisabled: false }];
    activitySubTypeOptions.forEach((item, index) => {
      options.push({ id: item.activitySubType, value: item.activitySubTypeName, isDisabled: false });
    });
    return options;
  }

  onActivitySubTypeSelected(optionSelected: CustomDropDown): void {
    if (optionSelected === null) {
      this.showActivitySubTypeValidation = this.selectedActivitySubType === '' ? true : false;
      this.customDropdownComponent.showError = this.selectedActivitySubType === '' ? true : false;
    } else {
      this.showActivitySubTypeValidation = false;
      this.customDropdownComponent.showError = false;
      this.selectedActivitySubType = optionSelected.value;
      this.selectedActivitySubTypeId = optionSelected.id;
      if (optionSelected.id > 0 || optionSelected.value === ACTIVITY_SUBTYPE_CONSTANTS.NQ41Q174) {
        this.targetForm.patchValue({ activityGroup: optionSelected.value, qpercentage: 0 });
        this.targetForm.controls['activityGroup'].disable();
        this.targetForm.controls['qpercentage'].disable();
        this.isNQA = true;
      }
      else {
        this.targetForm.patchValue({ activityGroup:'', qpercentage: 100 });
        this.targetForm.controls['activityGroup'].enable();
        this.targetForm.controls['qpercentage'].enable();
      }
    }
    this.isActivitySubTypeSelected = !this.showActivitySubTypeValidation;
    this.OnActivityChange();
  }

  isBtnDisabled() {
    if (!this.targetForm.valid) {
      return true;
    }
    else if (!this.isActivitySubTypeSelected) {
      return true;
    } else {
      return false;
    }
  }
}
